import { Component, Input, ViewChild } from '@angular/core';
import { VouchersService } from '../../services/vouchers.service';
import { VoucherDetailsModalComponent } from '../voucher-details-modal/voucher-details-modal.component';
import { ToasterService } from '../../services/toaster.service';
import { GTMService } from 'src/app/services/gtm.service';
import * as moment from 'moment';

@Component({
  selector: 'vouchers-card',
  styleUrls: ['./voucher-card.component.scss'],
  providers: [GTMService, ToasterService, VouchersService],
  template: `
    <div class="voucher" >
      <ng-core-loading class="loading" *ngIf="loading"></ng-core-loading>

      <img [src]="voucher?.vouchers_provider?.logo_url" alt="Voucher">
      <b>R$ {{voucher?.amount}} para usar no {{voucher?.vouchers_provider?.name}}</b>
      <span *ngIf="!toGenerate">Válido até {{voucher?.expired_voucher  | date: "dd/MM/yy"}}</span>
      <span *ngIf="toGenerate">Válido por 2 meses</span>

      <button class="btn" *ngIf="toGenerate && !isExpired" (click)="generateVoucher()">Gerar voucher</button>
      <button class="btn outline" *ngIf="!toGenerate && !isExpired" (click)="openDetailsModal()">Ver voucher</button>
      <button class="btn outline" *ngIf="isExpired" disabled>Voucher expirado</button>
    </div>

    <voucher-details-modal #modal [voucher]="voucher"></voucher-details-modal>
  `,
})
export class VoucherCardComponent {
  @ViewChild('modal')
  modal: VoucherDetailsModalComponent;

  @Input()
  voucher: any;

  @Input()
  toGenerate = false;

  loading = false;

  constructor(
    private vouchersService: VouchersService,
    private toastService: ToasterService,
    private gtm: GTMService
  ) {}

  get isExpired() {
    if (this.voucher && this.voucher.expired_voucher) {
      return moment(this.voucher.expired_voucher).isBefore(moment());
    }
  }

  generateVoucher() {
    this.loading = true;
    this.gtm.interaction('allya:mgm', 'mgm:meus-vouchers:click', 'gerar-voucher');

    this.vouchersService.generateVoucher().subscribe(({ voucher }) => {
      if (voucher && voucher.length) {
        this.voucher = {...this.voucher, ...voucher[0]};
        this.toGenerate = false;
        this.loading = false;
        this.openDetailsModal();
        this.vouchersService.setVoucherView([voucher[0].id]).subscribe();
      } else {
        this.toastService.info('Erro', 'Não foi possível criar o voucher', true, 4000);
        this.loading = false;
      }
    }, () => {
      this.toastService.info('Erro', 'Não foi possível criar o voucher', true, 4000);
      this.loading = false;
    });

  }

  openDetailsModal() {
    this.modal.open();
    this.gtm.interaction('allya:mgm', 'mgm:meus-vouchers:click', 'ver-voucher');
  }
}
